/**
 * Created by rickborst on 31/07/2017.
 */

import _ from 'lodash';

import {
    DeviceTypes,
    Errors
} from 'models/device';

/**
 * Converts application device types to api device types.
 *
 * @param {string} type - Device type.
 * @returns {number} Device type.
 */
function convertDeviceTypeForRequest (type) {

    switch (type) {

        case DeviceTypes.DESKTOP:
            return 22;
    }
}

/**
 * Converts api device types to application device types.
 *
 * @param {number} type - Device type.
 * @returns {string} Device type.
 */
function convertDeviceTypeFromRequest (type) {

    switch (type) {

        case 22:  // PC / MAC
            return DeviceTypes.DESKTOP;

        case 3:   // iPad
        case 4:   // Samsung Galaxy Tab
        case 31:  // Android (tablet)
            return DeviceTypes.TABLET;

        case 1:   // iPhone
        case 2:   // Samsung Galaxy S
        case 32:  // Android
            return DeviceTypes.MOBILE;
        case 20:  // Samsung TV
        case 102: // Apple TV
        case 105: // Android TV
            return DeviceTypes.TV;

        default:
            return DeviceTypes.UNKNOWN;
    }
}

/**
 * Converts application data to request data.
 *
 * @param {Object} user - User object.
 * @returns {Object} Request data.
 */
function convertForGetDevices (user) {

    return {
        orderBy: 'NONE',
        deviceFamilyIdIn: '',
        householdIdEqual: user.householdId
    };
}

/**
 * Converts an entry from a read action.
 *
 * @param {Object} entry - Read entry.
 * @returns {Object} Application data.
 */
function convertEntryFromRead (entry = {}) {

    return {
        udid: entry.udid || '',
        name: entry.name || '',
        householdId: entry.householdId || 0,
        activationDate: entry.activatedOn ? entry.activatedOn * 1000 : null,
        type: convertDeviceTypeFromRequest(entry.brandId),
        apiSpecifics: {
            brandId: entry.brandId || 0,
            status: entry.status || '',
            deviceFamilyId: entry.deviceFamilyId || 0
        }
    };
}

/**
 * Converts api data to application data.
 *
 * @param {Object} response - Response data.
 * @returns {Array} Array of device entries.
 */
function convertFromGetDevices (response) {
    let data = _.get(response, ['result', 'objects']);

    return _.map(data, convertEntryFromRead.bind(this));
}

/**
 * Converts application data to request data.
 *
 * @param {Object} device - Device object.
 * @returns {Object} Request data.
 */
function convertForAddDevice (device) {

    return {
        device: {
            objectType: 'KalturaHouseholdDevice',
            udid: device.udid,
            name: device.name,
            brandId: convertDeviceTypeForRequest(DeviceTypes.DESKTOP),
            activatedOn: Math.floor(device.activationDate / 1000)
        }
    };
}

/**
 * Converts api data to application data.
 *
 * @param {Object} response - Response data.
 * @returns {Object} Application data.
 */
function convertFromAddDevice (response) {
    let entry = _.get(response, ['result']);

    return convertEntryFromRead.call(this, entry);
}

/**
 * Converts api data to application data.
 *
 * @param {Object} response - Response data.
 * @returns {string} Application data.
 */
function convertFromAddDeviceError (response) {
    let error = _.get(response, ['result', 'error']);

    if (!error) {
        return true;
    }

    switch (error.code) {

        case '1001':
            return Errors.DEVICE_LIMIT_REACHED;

        case '1016':
            return Errors.DEVICE_IN_ANOTHER_HOUSEHOLD;

        default:
            return Errors.UNKNOWN;
    }
}

/**
 * Converts application data to request data.
 *
 * @param {Object} device - Device object.
 * @returns {Object} Request data.
 */
function convertForDeleteDevice (device) {

    return {
        udid: device.udid
    };
}

/**
 * Converts api data to application data.
 *
 * @returns {Object} Application data.
 */
function convertFromDeleteDevice () {

    return {};
}

/**
 * Converts application data to api data.
 *
 * @param {Array} devices - Device objects.
 * @returns {Object} Request data.
 */
function convertForDeleteDevices (devices) {
    let requestPayload = {};

    _.forEach(devices, (device, index) => {

        requestPayload[index + 1] = {
            service: 'householddevice',
            action: 'delete',
            udid: device.udid
        };
    });

    return requestPayload;
}

/**
 * Converts apu data to application data.
 *
 * @returns {Array} Application data.
 */
function convertFromDeleteDevices () {

    return [];
}

export {
    DeviceTypes,
    convertForGetDevices,
    convertFromGetDevices,
    convertForAddDevice,
    convertFromAddDevice,
    convertFromAddDeviceError,
    convertForDeleteDevice,
    convertFromDeleteDevice,
    convertForDeleteDevices,
    convertFromDeleteDevices
};


// WEBPACK FOOTER //
// ./src/js/datasources/kaltura/adapters/devices.js